// The head of a sidebar section that folds (Project, Riwayat): the section
// name as a button with a chevron, aria-expanded and aria-controls on the
// list it folds. The open or folded state lives in lib/prefs (per browser).
import { Glyph } from "../ui/icons";

export interface SectionHeadProps {
  /** The h2's id (the section's aria-labelledby). */
  id: string;
  title: string;
  open: boolean;
  onToggle: () => void;
  /** The id of the element the head folds. */
  controls: string;
}

export function SectionHead({ id, title, open, onToggle, controls }: SectionHeadProps) {
  return (
    <div className="cs-section-head">
      <h2 id={id} className="cs-section-title">
        <button type="button" className="cs-section-toggle" aria-expanded={open} aria-controls={controls} title={open ? `Ciutkan ${title}` : `Luaskan ${title}`} onClick={onToggle}>
          <span>{title}</span>
          <Glyph name="chevronRight" size={16} />
        </button>
      </h2>
    </div>
  );
}
